module.exports = __webpack_public_path__ + "static/media/realestate2.f8a63e5d.png";